<div class="wrapper_admin">
  <h4 class="title tipo-second-color bold">Ficha de usuario</h4>
  <div class="maxwidth">
    <app-header-user [companyData]="companyData" [isDigital]="isDigital" [userData]="userData" [roleUser]="roleUser"></app-header-user>
    @if (isProfessionalRoute()) {
      <app-file-doctor (userData)="receiveDoctorData($event)"></app-file-doctor>
      @if (false) {
        <div class="box-container">
          <div class="box box2">
            <!--TODO mostrar la firma del médico  -->
            <app-edit-sign></app-edit-sign>
          </div>
          <!--TODO mostrar las credenciales de firma  -->
          <app-data-professional></app-data-professional>
        </div>
      }
    } @else {
      <app-file-administrator (dataAdmin)="receiveAdminData($event)"></app-file-administrator>
    }


  </div>
</div>

